module.exports = __webpack_public_path__ + "img/principles_of_justice_button.00d2ce9f.jpg";